<template>
  <v-chip
    @click="handleClick"
    :class="{ 'staff-document-status-badge--clickable': clickable }"
    :color="chipColor"
    :ripple="clickable"
    data-cy="staff_document_status"
    size="small"
    variant="flat"
  >
    {{ status }}
  </v-chip>
</template>

<script setup>
import { DISPLAY_STATUSES } from '@/shared/utils/staffDocumentUtils';

const props = defineProps({
  clickable: {
    type: Boolean,
    default: false,
  },
  status: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['click']);

const chipColor = computed(() => {
  if (props.status === DISPLAY_STATUSES.ACTIVE) return 'success';
  if (props.status === DISPLAY_STATUSES.MISSING) return 'grey-lighten-3';
  if (props.status === DISPLAY_STATUSES.PENDING) return 'primary';
  if (props.status === DISPLAY_STATUSES.EXPIRED) return 'black';
  if (props.status === DISPLAY_STATUSES.DENIED) return 'error';
  return 'grey-lighten-3';
});

function handleClick(event) {
  if (!props.clickable) return;
  emit('click', event);
}
</script>

<style scoped>
.staff-document-status-badge--clickable {
  cursor: pointer;
}

.v-chip:not(.staff-document-status-badge--clickable) {
  cursor: default;
  pointer-events: none;
}
</style>
